const prefix = {
    user: '/u',
    dashboard: '/painel'
};

const paths = {
    // onboarding
    login: '/entrar',
    register: '/cadastrar',
    recoverAccount: '/recuperar-conta',  
    
    home: '/',

    events: {
        page: '/evento',
        home: '/eventos',
        trendboard: '/eventos-em-alta',
        listing: (citySlug) => `/eventos/${citySlug}`,
        establishment: (eventSlug, establishmentSlug) => `/evento/${eventSlug}/estabelecimento/${establishmentSlug}`,
        search: '/eventos/buscar',
    },

    partner: {
        createAccount: '/quero-ser-parceiro'
    },

    producer: {
        page: '/produtor',
    },

    establishments: {
        page: '/estabelecimento',
        home: '/estabelecimentos',
        trendboard: '/eventos-em-alta',
        listing: (citySlug) => `/estabelecimentos/${citySlug}`,
        search: '/estabelecimentos/buscar',
    },
    
    user: {
        profile: '/perfil',
        // Perfil público de uma pessoa: o link que o app compartilha.
        public: (username) => `${prefix.user}/${username}`,
        // following: `${prefix.user}/:user/seguindo`,
        // followers: `${prefix.user}/:user/seguidores`,
        wallet: `/carteira`,
        affiliate: '/indicacoes',
        reservations: '/minhas-reservas',
    },

    checkout: {
        orders: '/checkout'
    },

    dashboard: {
        home: `${prefix.dashboard}/produtor/perfil`,
        profile: `${prefix.dashboard}/produtor/perfil`,
        resume: `${prefix.dashboard}/produtor/resumo`,
        products: `${prefix.dashboard}/produtor/produtos`,
        events: `${prefix.dashboard}/produtor/eventos`,
        financial: `${prefix.dashboard}/produtor/financeiro`,
        support: `${prefix.dashboard}/produtor/suporte`,
        checkin: `${prefix.dashboard}/produtor/checkin`,
        orders: `${prefix.dashboard}/produtor/pedidos`,
        orders_establishment: `${prefix.dashboard}/produtor/pdv`,
        statistics: `${prefix.dashboard}/produtor/estatisticas`,
        affiliate: `${prefix.dashboard}/produtor/indicacoes`,
        customers: `${prefix.dashboard}/produtor/clientes`,
        campaigns: `${prefix.dashboard}/produtor/campanhas`,
        instagram: `${prefix.dashboard}/produtor/instagram`,
        teams: `${prefix.dashboard}/produtor/equipes`,
        producer: {
            root: `${prefix.dashboard}/produtor`,
        },
        establishment: {
            root:           `${prefix.dashboard}/estabelecimento`,
            profile:        `${prefix.dashboard}/estabelecimento/perfil`,
            menu:           `${prefix.dashboard}/estabelecimento/cardapio`,
            posEvents:      `${prefix.dashboard}/estabelecimento/eventos`,
            kitchen:        `${prefix.dashboard}/estabelecimento/pedidos`,
            waiter:         `${prefix.dashboard}/estabelecimento/comandas`,
            admin:          `${prefix.dashboard}/estabelecimento/administracao`,
            statistics:     `${prefix.dashboard}/estabelecimento/estatisticas`,
            cashier:        `${prefix.dashboard}/estabelecimento/caixa`,
            cashierSession: (id) => `${prefix.dashboard}/estabelecimento/caixa/${id}`,
            customers:      `${prefix.dashboard}/estabelecimento/clientes`,
            promotions:     `${prefix.dashboard}/estabelecimento/promocoes`,
            inventory:      `${prefix.dashboard}/estabelecimento/estoque`,
            reservations:   `${prefix.dashboard}/estabelecimento/reservas`,
            affiliate:      `${prefix.dashboard}/estabelecimento/indicacoes`,
        },
    },

    restaurant: {
        publicMenu:  '/:slug/menu',
        waiterApp:   '/:slug/garcom',
        stationApp:  '/:slug/estacao/:stationSlug',
    },

    otp: {
        login: '/acesso',
    },

    terms: {
        useTerms: '/termos-de-uso',
        policiePrivacy: '/politica-de-privacidade',
        policiePrivacyPDV: '/politica-de-privacidade-pdv',
        deleteAccount: '/exclusao-de-conta',
    },

    contact: '/contato',

    // Landing ainda não existe — cadastrada aqui pra centralizar o link do
    // PromoBannersCarousel e trocar num só lugar quando a página for criada.
    promotions: {
        threeYears: '/3-anos-whizr',
    },
};


export default paths;                   